module.exports = __webpack_public_path__ + "img/rule-SMEA.a98f707e.svg";